import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledCarousel } from './Carousel.styles';
import PagingDots from './PagingDots';
import PagingArrows from './PagingArrows';
import BlankSlide from './BlankSlide';
import Slide from './Slide';
import { colors } from '../css';

/**
 * Using Nuka Carousel from Formidible Labs
 * https://github.com/FormidableLabs/nuka-carousel
 */
const themes = {
  primary: {
    arrowColor: colors.colorWhite,
    dotColor: colors.colorBlue
  },
  secondary: {
    arrowColor: colors.colorBurgundy,
    dotColor: colors.colorBurgundy
  }
};

const themeNames = Object.keys(themes);
const [DEFAULT_THEME] = themeNames;
class Container extends Component {
  static propTypes = {
    /**
     * Any contained React Object can be a Slide in the carousel. For Specific Styling see the Slide Component
     */
    children: PropTypes.node.isRequired,
    /**
     *  The image for the entire carousel. If used this image will not swipe with the individual slides.
     *  Background Image will win over Color
     *  - if any slide has a background image or color set it will overwrite this image.
     */
    backgroundImage: PropTypes.string,
    /**
     *  The color for the entire carousel. If used this color will not swipe with the individual slides.
     *  Background Image will win over Color
     *  - if any slide has a background image or color set it will overwrite this image.
     */
    backgroundColor: PropTypes.string,
    /**
     * Use this property to change the color of the pagination dots & next/prev arrows
     */
    theme: PropTypes.oneOf(themeNames),

    /**
     * Boolean value that shows/hides controls
     */
    showControls: PropTypes.bool,
    /**
     * Boolean value that peaks 20% of next slide (or prev slide if user is on last slide)
     */
    peekNextSlide: PropTypes.bool,
    /**
     * Boolean value that controls whether pagination dots display on top of the slides or below them
     */
    dotsUnder: PropTypes.bool,
    /**
     * This controls the in/out when you hit the edge of the carousel. for more info take a look at the d3 easing library nuka carousel is using here https://github.com/d3/d3-ease
     */
    edgeEasing: PropTypes.string
  };

  static defaultProps = {
    backgroundImage: undefined,
    backgroundColor: undefined,
    theme: DEFAULT_THEME,
    showControls: true,
    peekNextSlide: false,
    dotsUnder: false,
    edgeEasing: 'easeSinOut'
  };

  componentDidMount() {
    /**
     * I'm sorry - I don't know how else to fix this carousel height issue...
     * If you have/find a better solution feel free to use it.
     */
    const event = document.createEvent('Event');
    setTimeout(() => {
      event.initEvent('resize', false, true);
      window.dispatchEvent(event);
    }, 1000);
  }

  render() {
    const { children, theme, showControls, peekNextSlide, edgeEasing } = this.props;

    const moreThanOneSlide = children.length > 1;

    return (
      <StyledCarousel
        edgeEasing={edgeEasing}
        {...this.props}
        slidesToShow={peekNextSlide ? 1.2 : 1}
        renderCenterLeftControls={props =>
          showControls && moreThanOneSlide ? (
            <PagingArrows onClick={props.previousSlide} direction="left" arrowColor={themes[theme].arrowColor} />
          ) : null
        }
        renderCenterRightControls={props =>
          showControls && moreThanOneSlide ? (
            <PagingArrows onClick={props.nextSlide} direction="right" arrowColor={themes[theme].arrowColor} />
          ) : null
        }
        renderBottomCenterControls={props =>
          showControls && moreThanOneSlide ? <PagingDots dotColor={themes[theme].dotColor} _ {...props} /> : null
        }
      >
        {children}
      </StyledCarousel>
    );
  }
}

export default { Container, Slide, BlankSlide };
